import { atom } from "jotai";

export const allCourses = atom([]);

export const courseStep = atom(3);
